module.exports = __webpack_public_path__ + "static/media/tree_sub_vertical_btn.21699d04.svg";